import { KEY_WIDGET_LAST_CHANGES } from '~/constants';
import { getFromLocalStorage, saveToLocalStorage } from '~/helpers/storage';

export const widgetsHasChanges = () => {

  const widgetLastChangesTime: {
    oldTime?: number;
    newTime?: number;
  }  = getFromLocalStorage(KEY_WIDGET_LAST_CHANGES, 'scenarios') || {};

  const oldTime = widgetLastChangesTime?.oldTime || 0;
  const newTime = widgetLastChangesTime?.newTime || 0;

  return oldTime !== newTime;

};

export const saveWidgetHasChanges = () => {

  const widgetLastChangesTime: {
    oldTime?: number;
    newTime?: number;


  }  = getFromLocalStorage(KEY_WIDGET_LAST_CHANGES, 'scenarios') || {};
  const oldTime = widgetLastChangesTime?.oldTime || 0;


  saveToLocalStorage(KEY_WIDGET_LAST_CHANGES, 'scenarios', {
    oldTime, newTime: oldTime,
  });

};
